import { render, staticRenderFns } from "./adresaElement.vue?vue&type=template&id=0c3edabf"
import script from "./adresaElement.vue?vue&type=script&lang=js"
export * from "./adresaElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports